interface GraphQLError {
  extensions?: {
    code: string | number;
  };
  message?: string;
}

interface ParseGqlErrorResult {
  message: string;
  code: string | number;
  type?: string;
  name?: string;
}

type TranslationFunction = (key: string, options?: { ns?: string }) => string;

const UNCOMPLETED_TASKS = 'UNCOMPLETED_TASKS';
const UNKNOWN_ERROR = 'UNKNOWN_ERROR';

const errorCodes = {
  11000: '11000',
  404: '404',
  402: '402',
  INVALID_FIELD: 'INVALID_FIELD',
  INVALID_PASSWORD: 'INVALID_PASSWORD',
  INVALID_LOGIN: 'INVALID_LOGIN',
  AUTHORIZATION_LIMIT: 'AUTHORIZATION_LIMIT',
  UNCOMPLETED_TASKS,
  TITLE: 'title',
  DESCRIPTION: 'description',
  STREET: 'street',
  COST: 'cost',
  CONTACT: 'contact',
  DUPLICATED_PROPOSUAL: 'DUPLICATED_PROPOSUAL',
  DUPLICATED_TENDER: 'DUPLICATED_TENDER',
  UNACCEPTABLE: 'UNACCEPTABLE',
  SUBSCRIPTION_EXISTS: 'SUBSCRIPTION_EXISTS',
  INVALID_EMAIL: 'INVALID_EMAIL',
  EMAIL_BUSY: 'EMAIL_BUSY',
  SUBDOMAIN_BUSY: 'SUBDOMAIN_BUSY',
  INTEGRATION_DUPLICATE_NAME: 'INTEGRATION_DUPLICATE_NAME',
  UNKNOWN_ERROR,
};

const parseGqlError = (
  graphQLErrors: GraphQLError[] = [],
  t: TranslationFunction = (key) => key
): ParseGqlErrorResult => {
  const extensions = graphQLErrors?.[0]?.extensions;
  if (extensions) {
    switch (extensions?.code.toString()) {
      case errorCodes[11000]:
        return {
          message: t('errors-messages.11000', { ns: 'common' }),
          code: errorCodes[11000],
        };
      case errorCodes.INVALID_FIELD:
        return {
          message: t('errors-messages.invalid-field', { ns: 'common' }),
          code: errorCodes.INVALID_FIELD,
          name: graphQLErrors?.[0]?.message?.replace(/.*(?=@)/, '')?.slice(1),
        };
      case errorCodes.SUBDOMAIN_BUSY:
        return {
          message: t('errors-messages.subdomain-busy', { ns: 'common' }),
          code: errorCodes.SUBDOMAIN_BUSY,
        };
      case errorCodes[404]:
        return {
          message: t('errors-messages.404', { ns: 'common' }),
          code: errorCodes[404],
        };
      case errorCodes[402]:
        return {
          message: t('errors-messages.payment-required', { ns: 'common' }),
          code: errorCodes[402],
        };
      case errorCodes.INVALID_LOGIN:
        return {
          message: t('errors-messages.invalid-login', { ns: 'common' }),
          code: errorCodes.INVALID_LOGIN,
        };
      case errorCodes.AUTHORIZATION_LIMIT:
        return {
          message: t('errors-messages.authorization-limit', { ns: 'common' }),
          code: errorCodes.AUTHORIZATION_LIMIT,
        };
      case errorCodes.INVALID_PASSWORD:
        return {
          message: t('errors-messages.invalid-password', { ns: 'common' }),
          code: errorCodes.INVALID_PASSWORD,
        };
      case errorCodes.TITLE:
        return {
          message: t('errors-messages.title', { ns: 'common' }),
          code: errorCodes.TITLE,
        };
      case errorCodes.DESCRIPTION:
        return {
          message: t('errors-messages.description', { ns: 'common' }),
          code: errorCodes.DESCRIPTION,
        };
      case errorCodes.STREET:
        return {
          message: t('errors-messages.street', { ns: 'common' }),
          code: errorCodes.STREET,
        };
      case errorCodes.COST:
        return {
          message: t('errors-messages.cost', { ns: 'common' }),
          code: errorCodes.COST,
        };
      case errorCodes.CONTACT:
        return {
          message: t('errors-messages.contact', { ns: 'common' }),
          code: errorCodes.CONTACT,
        };
      case errorCodes.DUPLICATED_PROPOSUAL:
        return {
          message: t('errors-messages.duplicated-proposual', { ns: 'common' }),
          code: errorCodes.DUPLICATED_PROPOSUAL,
        };
      case errorCodes.DUPLICATED_TENDER:
        return {
          message: t('errors-messages.duplicated-tender', { ns: 'common' }),
          code: errorCodes.DUPLICATED_TENDER,
        };
      case errorCodes.UNACCEPTABLE:
        return {
          message: t('errors-messages.unacceptable', { ns: 'common' }),
          code: errorCodes.UNACCEPTABLE,
        };
      case errorCodes.SUBSCRIPTION_EXISTS:
        return {
          message: t('errors-messages.subscription-exists', { ns: 'common' }),
          code: errorCodes.SUBSCRIPTION_EXISTS,
        };
      case errorCodes.INVALID_EMAIL:
        return {
          message: t('errors-messages.invalid-email', { ns: 'common' }),
          code: errorCodes.INVALID_EMAIL,
        };
      case errorCodes.EMAIL_BUSY:
        return {
          message: t('errors-messages.email-busy', { ns: 'common' }),
          code: errorCodes.EMAIL_BUSY,
        };
      case errorCodes.INTEGRATION_DUPLICATE_NAME:
        return {
          message: t('errors-messages.integration-duplicate-name', { ns: 'common' }),
          code: errorCodes.INTEGRATION_DUPLICATE_NAME,
        };
      default:
        break;
    }
  }
  return {
    message: t('errors-messages.default-error', { ns: 'common' }),
    code: graphQLErrors?.[0]?.extensions?.code || UNKNOWN_ERROR,
    type: errorCodes[UNKNOWN_ERROR],
  };
};

export { parseGqlError, errorCodes, UNKNOWN_ERROR };
export type { GraphQLError, ParseGqlErrorResult, TranslationFunction };
